import { Timestamp } from "firebase/firestore";
import { StringLiteral } from "typescript";
import { getCurrentTimeStamp } from "../utility/datehelper";
import { DisplayMode, IGridItem } from "../common/controls/GenericGrid";
import { Identifiable } from "./Identifiable";

export interface Category extends Identifiable {
    id:string;
    name: string;
    title: string;
    description?: string;    
    categoryType:string;
    displayMode:string;    
    categoryImage:string;
    categoryVideo:string;
    isActive:boolean;    
    actionDate:Timestamp;
    actionBy:string;
    displayOrder:number;
    parentId: string;
}
export class Category implements IGridItem
{
    constructor(category?:Category)
    {
        if(category)
        {
            Object.assign(this,category);
        }
    }
    id:string = "";
    name: string="";
    title: string="";
    description?: string="";    
    categoryType:string="";
    displayMode: string = "image";    
    categoryImage:string="";
    categoryVideo:string = "";
    isActive:boolean = false;
    actionDate:Timestamp= getCurrentTimeStamp();
    actionBy:string="SuperAdmin";
    displayOrder:number = 0;
    parentId:string = "";
}